import { regions, locations, details, searchResults } from './data';
import { delay } from 'Common/utils';

export const loadRegions = () => {
  return delay(500).then(() => {
    if (typeof regions === 'undefined') {
      throw Error('kuku');
    } else {
      return regions;
    }
  });
};

export const loadRegionsDirectly = () => {
  return delay(500).then(() => {
    if (typeof regions === 'undefined') {
      throw Error('kuku');
    } else {
      return { body: JSON.stringify(regions) };
    }
  });
};

export const loadLocations = (regionId) => {
  return delay(500).then(() => {
    if (typeof locations === 'undefined') {
      throw Error('kuku');
    } else {
      return locations;
    }
  });
};

export const loadDetail = (id) => {
  return delay(500).then(() => {
    if (typeof details === 'undefined') {
      throw Error('kuku');
    } else {
      return details;
    }
  });
};

export const search = (searchTerm) => {
  console.log('searching for', searchTerm);
  return delay(500).then(() => {
    return searchResults;
  });
};

export function submitApplication(value) {
  console.log('Submitting application with data: ', value);
  return delay(500).then(() => ({
    ok: true,
    body: {
      code: 200,
      status: true,
      message: 'success',
      result: {
        request_id: '40227-s/22',
        token: '84ad92ab8c',
      },
    },
  }));
}



// WEBPACK FOOTER //
// ./src/apps/receptions/fake-api/api.js